import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Card, CardContent, Divider } from '@mui/material';
import QuestionRank from './QuestionRank';
import MasseuseRank from './MasseuseRank';
import MassageRank from './MassageRank';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Rankings() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Card variant="outlined" className="ranking-card">
      <CardContent>
        <Typography variant="h2" color="#FFF" gutterBottom>
          Rankings
        </Typography>
        <Divider color="#FFF" sx={{ borderBottomWidth: 5 }} />
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              textColor="secondary"
              indicatorColor="secondary"
            >
              <Tab label="Question Rank" {...a11yProps(0)} />
              <Tab label="Masseuse Rank" {...a11yProps(1)} />
              <Tab label="Massage Rank" {...a11yProps(2)} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <QuestionRank />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <MasseuseRank />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <MassageRank />
          </TabPanel>
        </Box>
      </CardContent>{' '}
    </Card>
  );
}
